<template>
  <div class="zj-monitor-infopanel">
    <el-row type="flex" justify="space-between">
      <el-col class="seq" :span="1">
        <div>{{ info.index + 1 }}</div>
      </el-col>
      <el-col
        :span="3"
        :class="
          info.Status == 1
            ? 'zj-monitor-infopanel-detail'
            : 'zj-monitor-infopanel-detailOff'
        "
        :style="
          info.Status == 1
            ? ''
            : 'background-color: rgba(102, 102, 102, 0.2) !important;'
        "
      >
        <el-row
          type="flex"
          justify="space-between"
          :class="
            info.Status == 1
              ? 'zj-monitor-infopanel-detail-border'
              : 'zj-monitor-infopanel-detail-borderOff'
          "
        >
          <div :class="info.Status == 1 ? 'color' : 'color_off'">
            <div class="statue">{{ info.Status == 1 ? "在线" : "离线" }}</div>
          </div>
          <img
            src="../../../theme-default/src/images/server_on.png"
            alt=""
            class="serverImg"
            v-if="info.Status == 1"
          />
          <img
            src="../../../theme-default/src/images/server_off.png"
            alt=""
            class="serverImg"
            v-if="info.Status != 1"
          />
        </el-row>
        <el-row>
          <div
            :class="
              info.UseDetail != null && info.UseDetail.Disk.length > 2
                ? 'serverInfo2'
                : 'serverInfo'
            "
          >
            <span :class="info.Status == 1 ? 'name' : 'name_off'">
              {{ info.Name }}</span
            >
          </div>
          <div
            :class="
              info.UseDetail != null && info.UseDetail.Disk.length > 2
                ? 'serverInfo2'
                : 'serverInfo'
            "
          >
            <span :class="info.Status == 1 ? 'name' : 'name_off'">{{
              info.IP
            }}</span>
          </div>
        </el-row>
      </el-col>
      <el-col
        :span="10"
        :class="
          info.Status == 1
            ? 'zj-monitor-infopanel-middle-border'
            : 'zj-monitor-infopanel-middle-borderOff'
        "
        :style="
          info.Status == 1
            ? ''
            : 'background-color: rgba(102, 102, 102, 0.2) !important;'
        "
      >
        <!-- <el-row> -->
        <el-col :span="10" :offset="1">
          <div class="cpu">
            <div :id="`cpuPie${info.index}`" class="pie_box"></div>
          </div>
          <!-- <div id="cpuPie0" class="pie_box"></div> -->
        </el-col>
        <el-col :span="6" :offset="1">
          <div class="cpuNet">
            <div class="netDiv">
              <img
                src="../../../theme-default/src/images/top.png"
                alt=""
                style="vertical-align: middle;"
              />
              <span class="net"
                >{{
                  this.info.UseDetail == null
                    ? "0"
                    : this.info.UseDetail.Network.UpBandwidth
                }}{{
                  this.info.UseDetail == null
                    ? "KB/S"
                    : this.info.UseDetail.Network.Unit
                }}</span
              >
            </div>
            <div class="netDiv"><span class="netFont">网络带宽上行</span></div>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="cpuNet">
            <div class="netDiv">
              <img
                src="../../../theme-default/src/images/bottom.png"
                alt=""
                style="vertical-align: middle;"
              />
              <span class="net"
                >{{
                  this.info.UseDetail == null
                    ? "0"
                    : this.info.UseDetail.Network.DownBandwidth
                }}{{
                  this.info.UseDetail == null
                    ? "KB/S"
                    : this.info.UseDetail.Network.Unit
                }}</span
              >
            </div>
            <div class="netDiv"><span class="netFont">网络带宽下行</span></div>
          </div>
        </el-col>
      </el-col>
      <el-col
        :span="10"
        :class="
          info.Status == 1
            ? 'zj-monitor-infopanel-right-border'
            : 'zj-monitor-infopanel-right-borderOff'
        "
        :style="
          info.Status == 1
            ? ''
            : 'background-color: rgba(102, 102, 102, 0.2) !important;'
        "
      >
        <div v-if="info.UseDetail != null">
          <div v-for="item in info.UseDetail.Disk" :key="item">
            <div class="progress">
              <img
                src="../../../theme-default/src/images/disk.png"
                alt=""
                class="progressImg"
              />
              <span class="diskFont1"
                >{{ item.Name.replace(":", "") }}盘空间
              </span>
              <el-progress
                :text-inside="false"
                :stroke-width="18"
                :percentage="item.UtilizationRate"
                :show-text="false"
                color="#44abd4"
              ></el-progress>
            </div>
            <div style="margin-left:82px;">
              <span class="diskFont2">
                {{ item.FreeSpace }}{{ item.Unit }}可用，共{{ item.TotalSpace
                }}{{ item.Unit }}</span
              >
            </div>
          </div>
        </div>
        <div v-if="info.UseDetail == null">
          <div>
            <div class="progress">
              <img
                src="../../../theme-default/src/images/disk.png"
                alt=""
                style="width:18px;height:18px;"
              />
              <span class="diskFont1">C盘空间 </span>
              <el-progress
                :text-inside="false"
                :stroke-width="18"
                :percentage="0"
                :show-text="false"
                color="#44abd4"
              ></el-progress>
            </div>
            <div class="progressSpace">
              <span class="diskFont2"> 99GB可用，共99GB</span>
            </div>
            <div class="progress">
              <img
                src="../../../theme-default/src/images/disk.png"
                alt=""
                class="progressImg"
              />
              <span class="diskFont1">D盘空间 </span>
              <el-progress
                :text-inside="false"
                :stroke-width="18"
                :percentage="0"
                :show-text="false"
                color="#44abd4"
              ></el-progress>
            </div>
            <div class="progressSpace">
              <span class="diskFont2"> 500GB可用，共500GB</span>
            </div>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>
<script>
export default {
  name: "MonitorInfoPanel",
  props: {
    info: {
      index: Number,
      id: String,
      Name: String,
      IP: String,
      UseDetail: Object,
      Status: Number,
    },
  },
  mounted: function() {
    this.drawPie();
  },
  methods: {
    drawPie() {
      let cpuValue =
        this.info.UseDetail == null
          ? "0%"
          : this.info.UseDetail.Cpu.UtilizationRate;
      let memoryValue =
        this.info.UseDetail == null
          ? "0%"
          : this.info.UseDetail.Memory.UtilizationRate + "%";

      var option = {
        title: [
          {
            text: "CPU使用率",
            left: "24%",
            top: "81%",
            textAlign: "center",
            textStyle: {
              color: "#d6f0ff",
              fontSize: "13",
              fontWeight: "normal",
              fontFamily: "Microsoft YaHei",
            },
          },
          {
            text: "内存使用率",
            left: "74%",
            top: "81%",
            textAlign: "center",
            textStyle: {
              color: "#d6f0ff",
              fontSize: "13",
              fontWeight: "normal",
              fontFamily: "Microsoft YaHei",
            },
          },
        ],
        series: [
          {
            type: "liquidFill",
            radius: "60%",
            // center: ["25%", "45%"],
            center: ["25%", "45%"],
            data: [
              { value: cpuValue },
              parseInt(cpuValue) / 100,
              parseInt(cpuValue) / 100,
              parseInt(cpuValue) / 100,
            ], // data个数代表波浪数
            backgroundStyle: {
              borderWidth: 3,
              borderColor: "#44abd4",
              color: "rgba(61, 159, 255, 0.2)",
            },
            color: ["#44abd4", "rgb(61, 159, 255)", "rgb(61, 159, 255)"],
            itemStyle: {
              opacity: 1,
            },
            emphasis: {
              itemStyle: {
                opacity: 0.9,
              },
            },
            label: {
              normal: {
                formatter: function(param) {
                  return param.value;
                },
                // formatter: ('{c}' * 100).toFixed(0) + "%",
                textStyle: {
                  fontSize: 12,
                  color: "#fff",
                },
              },
            },
            outline: {
              borderDistance: 0,
              itemStyle: {
                borderWidth: 6,
                borderColor: "rgba(61, 159, 255, 0.2)",
              },
            },
          },
          {
            type: "liquidFill",
            radius: "60%",
            center: ["75%", "45%"],
            data: [
              { value: memoryValue },
              parseInt(memoryValue) / 100,
              parseInt(memoryValue) / 100,
              parseInt(memoryValue) / 100,
            ], // data个数代表波浪数
            color: ["rgb(217, 72, 77)", "rgb(217, 72, 77)", "rgb(217, 72, 77)"],
            backgroundStyle: {
              borderWidth: 3,
              borderColor: "rgb(217, 72, 77)",
              color: "rgba(217, 72, 77, 0.2)",
            },
            label: {
              normal: {
                formatter: function(param) {
                  return param.value;
                },
                // formatter: ('{c}' * 100).toFixed(0) + "%",
                textStyle: {
                  fontSize: 12,
                  color: "#fff",
                },
              },
            },
            outline: {
              borderDistance: 0,
              itemStyle: {
                borderWidth: 6,
                borderColor: "rgba(217, 72, 77, 0.2)",
              },
            },
          },
        ],
      };

      var chartDom = document.getElementById("cpuPie" + this.info.index);
      // eslint-disable-next-line no-undef
      var myChart = echarts.getInstanceByDom(chartDom);
      if (!myChart) {
        // eslint-disable-next-line no-undef
        myChart = echarts.init(chartDom);
        myChart.setOption(option);
      }
      // myChart.clear();
      // myChart.setOption(option);
      window.onresize = function() {
        myChart.resize();
      };
    },
  },
};
</script>

<style></style>
